import TaxRegimeRepository from '../domain/taxRegimeRepository';
import httpService from '../../../services/httpService';

export default class RemoteTaxRegimeRepository extends TaxRegimeRepository {
  async getAll() {
    const { data } = await httpService.get('/regimenFiscal');
    return data;
  }
}
